function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4 8.46191C14.4 10.1593 13.7257 11.7872 12.5255 12.9874C11.3253 14.1876 9.69739 14.8619 8 14.8619C6.30261 14.8619 4.67475 14.1876 3.47452 12.9874C2.27428 11.7872 1.6 10.1593 1.6 8.46191C1.6 6.76453 2.27428 5.13666 3.47452 3.93643C4.67475 2.7362 6.30261 2.06191 8 2.06191C8.608 2.06191 9.2 2.14991 9.76 2.30991L11.016 1.05391C10.088 0.669914 9.072 0.461914 8 0.461914C6.94943 0.461914 5.90914 0.66884 4.93853 1.07088C3.96793 1.47292 3.08601 2.06219 2.34315 2.80506C0.842855 4.30535 0 6.34018 0 8.46191C0 10.5836 0.842855 12.6185 2.34315 14.1188C3.08601 14.8616 3.96793 15.4509 4.93853 15.853C5.90914 16.255 6.94943 16.4619 8 16.4619C10.1217 16.4619 12.1566 15.6191 13.6569 14.1188C15.1571 12.6185 16 10.5836 16 8.46191H14.4ZM4.728 6.92591L3.6 8.06191L7.2 11.6619L15.2 3.66191L14.072 2.52591L7.2 9.39791L4.728 6.92591Z",
  fill: "#2EB74A"
});

function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.c63197ff.svg";
export { ForwardRef as ReactComponent };